import { combineReducers, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import { pendingTasksReducer } from 'react-redux-spinner';
import coreReducers from './reducers';
import adminReducers from '../Admin/store/reducers';
import managerReducers from '../Manager/store/reducers';
import employeeReducers from '../Employee/store/reducers';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
    // other options if needed
});
const middleware = [thunk, routerMiddleware];

const reducers = combineReducers({
    ...coreReducers,
    ...adminReducers,
    ...managerReducers,
    ...employeeReducers,
    pendingTasks: pendingTasksReducer,
    router: routerReducer,
});

export const store = createStore(
    reducers,
    composeWithDevTools(applyMiddleware(...middleware)),
);

export const history = createReduxHistory(store);
